import { animate } from 'motion';
import { setupLinkHoverAnimations } from '../utils/linkAnimations';

/**
 * Initialize mobile menu functionality with animations
 */
export function initMobileMenu() {
  const mobileMenuButton = document.querySelector('.mobile-menu-button');
  const mobileMenu = document.querySelector('.mobile-menu');
  const hamburgerIcon = mobileMenuButton?.querySelector('svg:first-of-type');
  const closeIcon = mobileMenuButton?.querySelector('svg:last-of-type');
  const overlay = document.getElementById('mobile-menu-overlay');

  // Don't proceed if elements don't exist
  if (!mobileMenuButton || !mobileMenu || !hamburgerIcon || !closeIcon || !overlay) {
    return;
  }

  // Track menu state
  let isMenuOpen = false;

  // Ensure the menu is initially hidden
  const initializeMenu = () => {
    // Force the menu to be hidden initially
    mobileMenu.style.transform = 'translateY(-100%)';
    mobileMenu.style.display = 'block';
    mobileMenu.style.visibility = 'visible';
    mobileMenu.style.overflow = 'hidden'; // Ensure no scrollbar appears
  };

  // Function to open the menu with animation
  const openMenu = () => {
    // Show close icon, hide hamburger icon
    hamburgerIcon.classList.add('hidden');
    closeIcon.classList.remove('hidden');

    // Set aria-expanded attribute
    mobileMenuButton.setAttribute('aria-expanded', 'true');

    // Make sure the menu is visible before animating
    mobileMenu.style.display = 'block';
    mobileMenu.style.visibility = 'visible';
    mobileMenu.style.overflow = 'hidden'; // Ensure no scrollbar appears

    // Make all menu items visible immediately
    const menuItems = mobileMenu.querySelectorAll('a, div');
    menuItems.forEach(item => {
      item.style.opacity = '1';
      item.style.transform = 'translateY(0)';
    });

    // Animate the menu sliding down from the top
    animate(mobileMenu, { transform: 'translateY(0)' }, {
      duration: 0.4,
      easing: [0.22, 1, 0.36, 1] // Custom cubic-bezier for smooth animation
    });

    isMenuOpen = true;

    // Set up hover animations for mobile menu links
    setupMobileMenuHoverAnimations();

    // Show overlay
    overlay.classList.remove('hidden');
  };

  // Function to close the menu with animation
  const closeMenu = () => {
    // Show hamburger icon, hide close icon
    hamburgerIcon.classList.remove('hidden');
    closeIcon.classList.add('hidden');

    // Set aria-expanded attribute
    mobileMenuButton.setAttribute('aria-expanded', 'false');

    // Animate the menu sliding back up
    animate(mobileMenu, { transform: 'translateY(-100%)' }, {
      duration: 0.3,
      easing: [0.22, 1, 0.36, 1] // Custom cubic-bezier for smooth animation
    });

    isMenuOpen = false;

    // Hide overlay
    overlay.classList.add('hidden');
  };

  // Set up hover animations for mobile menu links
  const setupMobileMenuHoverAnimations = () => {
    const mobileNavLinks = mobileMenu.querySelectorAll('.nav-link');
    setupLinkHoverAnimations(mobileNavLinks, { circleSize: '36px' });
  };

  // Toggle menu on button click
  mobileMenuButton.addEventListener('click', () => {
    if (isMenuOpen) {
      closeMenu();
    } else {
      openMenu();
    }
  });

  // Close menu when clicking on a link
  mobileMenu.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', closeMenu);
  });

  // Close menu on window resize if it would switch to desktop view
  window.addEventListener('resize', () => {
    if (window.innerWidth >= 1024 && isMenuOpen) { // 1024px is the lg breakpoint in Tailwind
      closeMenu();
    }
  });

  // Initialize menu state
  initializeMenu();
}

export default initMobileMenu;
